module.exports = __webpack_public_path__ + "static/img/traffic-charactor.7159573e.svg";